export enum EProjectsActions {
    GET_PROJECT = 'GET_PROJECT',
    GET_PROJECTS = 'GET_PROJECTS',
    GET_FILTERS = 'GET_FILTERS',
}
